import { render, staticRenderFns } from "./PrePostTotalByYear.vue?vue&type=template&id=52b96ccc"
import script from "./PrePostTotalByYear.vue?vue&type=script&lang=js"
export * from "./PrePostTotalByYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports